export const hasOrganizationPermission = (auth, permissionTitle) => {
  if (!auth) return true;

  const { me } = auth || {};
  const { activeOrganization = {} } = me || {};
  const { permissions = [] } = activeOrganization || {};
  const hasEditBookingPermission = permissions.includes(permissionTitle);
  return hasEditBookingPermission;
};
